import React, { Profiler, useContext, useEffect } from "react";
import { useTheme } from "@bookingcom/bui-react";
import PopularFlights from "../components/elements/PopularFlights/index.js";
import FrequentlyAskedQuestions from "../components/elements/FrequentlyAskedQuestions/FrequentlyAskedQuestions.js";
import UspBlock from "../components/elements/UspBlock/index.js";
import { trackMetaLandingsCustomGoalsV2 } from "../utils/experiments/track-meta-landings-v2.js";
import { SearchDesktop, SearchOutboundDesktop } from "../app/routes.js";
import { AppShellDesktop } from "../components/elements/AppShell/index.js";
import Container from "../components/elements/Container/index.js";
import useClientMetrics from "../hooks/useClientMetrics.js";
import useTrackPageLoad from "../hooks/useTrackPageLoad.js";
import { PageHeader } from "./Home.js";
import StaticContext from "../app/StaticContext/StaticContext.js";
import HomeRecentSearch from "../components/elements/HomeRecentSearch/index.js";
import Frame from "../components/elements/Frame/index.js";
import { HomeSearchHeaderDesktop } from "../components/elements/HomeSearchHeader/index.js";
import { RemoteAppleCardIndex, RemoteGeniusLaunchSheet, RemoteGeniusLoyalty, RemoteRewardsLandSheet } from "../components/remote/index.js";
import NoSSR from "../app/NoSSR/index.js";
import useLandingPageEvents from "../hooks/c360/useLandingPageEvents.js";
import { GeniusFlightsHomeBanner } from "../components/elements/FlightCampaignTCBanner/GeniusHomeBanner.js";
import { goal } from "@flights/et-universal";
import { FlightsInterlinkingDesktop } from "../components/elements/FlightsInterlinking/index.js";
import FlyAnywhereCountriesCarousel from "../components/elements/FlyAnywhere/FlyAnywhereCountriesCarousel.js";
import HomepageOffers from "../components/elements/HomepageOffers/index.js";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us.js";
import FlyAnywhereMapBanner from "../components/elements/FlyAnywhere/FlyAnywhereMap/FlyAnywhereMapBanner.js";
import { useIsMapViewExp } from "../components/elements/FlyAnywhere/hooks/useIsMapViewExp.js";
import flights_web_cat_fly_anywhere_map_view_www from "../utils/experiments/cat/flights_web_cat_fly_anywhere_map_view_www.js";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { useAdTechIndexTag } from "../hooks/useAdTechGTMTags.js";
import { MiddleEastBanner } from "../components/elements/MiddleEastBanner/MiddleEastBanner.js";
import useGlobalContext from "../hooks/useGlobalContext.js";
const HomeDesktop = ({ getInitialState }) => {
    const staticContext = useContext(StaticContext);
    const theme = useTheme();
    const trackContextEventV2 = useTrackPageLoad("index");
    const { trackRenderTime } = useClientMetrics();
    const trackLandingPageEvents = useLandingPageEvents();
    const { isSplitBounds } = useSplitBoundsCondition();
    const { features } = useGlobalContext();
    const isMapViewExp = useIsMapViewExp();
    const fireAdTechIndexTag = useAdTechIndexTag();
    if (getInitialState && staticContext.set) {
        staticContext.set({ getInitialState: getInitialState() });
    }
    useEffect(() => {
        SearchDesktop.preload();
        if (isSplitBounds) {
            SearchOutboundDesktop.preload();
        }
        flightsSessionStore.set("index_page_load_time", Date.now());
        trackContextEventV2();
        goal("flights_home_page_view");
        goal("tbu_vertical_home_page_view");
        trackLandingPageEvents("page_view", "homepage");
        trackMetaLandingsCustomGoalsV2(2, "desktop");
        flights_web_cat_fly_anywhere_map_view_www.stages.main();
        void fireAdTechIndexTag();
    }, []);
    return (React.createElement(Profiler, { id: "screen", onRender: trackRenderTime },
        React.createElement(PageHeader, null),
        React.createElement(AppShellDesktop, null,
            React.createElement(Frame, { alignItems: "center", direction: "column", justifyContent: "center", grow: 1, attributes: { style: { width: "100%" } } },
                React.createElement(HomeSearchHeaderDesktop, null),
                features.FLIGHTS_WEB_PB_CS_HIGH_VOLUMES_BANNER ? (React.createElement(Container, { pt: 4 },
                    React.createElement(MiddleEastBanner, null))) : undefined,
                React.createElement(NoSSR, null,
                    React.createElement(HomeRecentSearch, null)),
                React.createElement(HomepageOffers, { isMobile: false }),
                isMapViewExp && (React.createElement(Container, { style: { margin: `${theme.units.spacing_8x} auto 0`, alignItems: "start" } },
                    React.createElement(FlyAnywhereMapBanner, null))),
                React.createElement(Container, { style: { margin: `${theme.units.spacing_8x} auto 0`, alignItems: "start" } },
                    React.createElement(FlyAnywhereCountriesCarousel, null)),
                React.createElement(GeniusFlightsHomeBanner, null),
                React.createElement(PopularFlights, { isMobile: false }),
                React.createElement(RemoteAppleCardIndex, null),
                React.createElement(RemoteGeniusLoyalty, null),
                React.createElement(Frame, { attributes: { style: { width: "100%" } }, mt: 8, mb: 8 },
                    React.createElement(UspBlock, null)),
                React.createElement(FlightsInterlinkingDesktop, null),
                React.createElement(Container, { pb: 8 },
                    React.createElement(FrequentlyAskedQuestions, null)))),
        React.createElement(RemoteGeniusLaunchSheet, null),
        React.createElement(RemoteRewardsLandSheet, null)));
};
export default HomeDesktop;
